module.exports = __webpack_public_path__ + "static/media/shamshair.d6b18e31.png";